(() => {
  'use strict';
  let toastTimer;
  const notify = message => {
    const toast = document.querySelector('.mp-post-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 2800);
  };
  const motion = new WeakMap();
  const feedback = new WeakMap();
  const animate = (element, frames, duration = 180) => {
    if (!element?.animate || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    motion.get(element)?.cancel();
    motion.set(element, element.animate(frames, { duration, easing: 'ease-out' }));
  };
  const pulse = (post, action) => {
    const icon = post.querySelector(`[data-post-${action}] .mp-icon`);
    if (!icon) return;
    clearTimeout(feedback.get(icon));
    icon.classList.add('is-feedback');
    feedback.set(icon, setTimeout(() => icon.classList.remove('is-feedback'), 900));
    animate(icon, [
      { transform: 'translateY(0) scale(1)' },
      { transform: 'translateY(-1px) scale(1.03)', offset: .4 },
      { transform: 'translateY(0) scale(1)' }
    ]);
  };
  const postLink = () => {
    const url = new URL('/', location.origin);
    url.searchParams.set('post', 'aldo-cart-post');
    const theme = window.Shopify?.theme;
    const previewId = theme?.role === 'unpublished' ? theme.id : new URL(location.href).searchParams.get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    url.hash = 'aldo-post';
    return url.href;
  };
  const counters = new WeakMap();
  const initializeLikes = () => document.querySelectorAll('[data-social-post]').forEach(post => {
    if (counters.has(post)) return;
    const endpoint = post.dataset.postLikesUrl;
    post.querySelector('[data-post-share-link]').value = postLink();
    const button = post.querySelector('[data-post-like]');
    const cart = post.closest('#MarketCartDialog');
    const confirmed = { like: 0, share: 0 };
    let stream, polling, reading = false;
    const renderCount = (action, count) => {
      if (!Number.isSafeInteger(count) || count < 0) return;
      const next = Math.max(confirmed[action], count);
      const element = post.querySelector(action === 'like' ? '[data-post-reaction-count]' : '[data-post-share-count]');
      confirmed[action] = next;
      element.textContent = next.toLocaleString();
      if (action === 'share') post.querySelector('[data-post-share-label]').textContent = next === 1 ? ' share' : ' shares';
    };
    try {
      renderCount('like', Number(sessionStorage.getItem('aldo-post-like-count')));
      renderCount('share', Number(sessionStorage.getItem('aldo-post-share-count')));
      if (localStorage.getItem('aldo-post-liked') === 'true') button.setAttribute('aria-pressed', 'true');
    } catch (_) {}
    const update = data => {
      renderCount('like', data.count);
      renderCount('share', data.shares);
      try {
        sessionStorage.setItem('aldo-post-like-count', String(confirmed.like));
        sessionStorage.setItem('aldo-post-share-count', String(confirmed.share));
      } catch (_) {}
    };
    const read = async () => {
      if (reading) return;
      reading = true;
      try {
        const response = await fetch(endpoint, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(12000) });
        if (response.ok) update(await response.json());
      } catch (_) {} finally { reading = false; }
    };
    const stop = () => { stream?.close(); stream = undefined; clearInterval(polling); polling = undefined; };
    const sync = () => {
      if (!post.isConnected || !cart?.open || document.hidden) { stop(); return; }
      post.querySelectorAll('[data-post-src]').forEach(image => {
        image.src = image.dataset.postSrc;
        image.removeAttribute('data-post-src');
      });
      if (stream || polling) return;
      if ('EventSource' in window) {
        const url = new URL(endpoint);
        url.searchParams.set('stream', '1');
        stream = new EventSource(url);
        stream.onmessage = event => { try { update(JSON.parse(event.data)); } catch (_) {} };
      } else {
        void read();
        polling = setInterval(read, 2500);
      }
    };
    const add = async (action = 'like') => {
      const clickId = crypto.randomUUID();
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const response = await fetch(endpoint, {
            method: 'POST', credentials: 'omit', cache: 'no-store',
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ clickId, action }),
            signal: AbortSignal.timeout(12000)
          });
          if (!response.ok) {
            if (response.status < 500 && response.status !== 429) break;
            throw new Error('Like service unavailable.');
          }
          update(await response.json());
          if (action === 'like') {
            button.setAttribute('aria-pressed', 'true');
            try { localStorage.setItem('aldo-post-liked', 'true'); } catch (_) {}
          }
          return;
        } catch (_) {
          if (attempt < 2) await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1)));
        }
      }
      notify(action === 'like' ? "Couldn't like the post. Try again." : "Shared. Couldn't update the count. Try again later.");
    };
    counters.set(post, { add });
    if (cart) new MutationObserver(sync).observe(cart, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', sync);
    sync();
  });
  initializeLikes();
  document.addEventListener('shopify:section:load', initializeLikes);
  const sharing = new WeakSet();
  const showShareLink = post => {
    const dialog = post.querySelector('.mp-post-share-dialog');
    const input = dialog.querySelector('[data-post-share-link]');
    input.value = postLink();
    if (!dialog.open) dialog.showModal();
    input.focus();
    input.select();
  };
  const copyPost = async post => {
    try {
      await navigator.clipboard.writeText(postLink());
      post.querySelector('.mp-post-share-dialog').close();
      pulse(post, 'share');
      notify('Link copied');
      void counters.get(post)?.add('share');
    } catch (_) { showShareLink(post); }
  };
  document.addEventListener('copy', event => {
    if (!event.isTrusted || !event.target.matches('[data-post-share-link]') || !event.clipboardData) return;
    const post = event.target.closest('[data-social-post]');
    event.clipboardData.setData('text/plain', postLink());
    event.preventDefault();
    pulse(post, 'share');
    notify('Link copied');
    void counters.get(post)?.add('share');
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('button');
    const post = button?.closest('[data-social-post]');
    if (!post) return;
    if (button.matches('[data-post-error-close]')) { button.closest('dialog').close(); return; }
    if (button.matches('[data-post-share-close]')) { button.closest('dialog').close(); return; }
    if (button.matches('[data-post-like]')) {
      pulse(post, 'like');
      counters.get(post)?.add();
    }
    if (button.matches('[data-post-focus-comment]')) post.querySelector('[data-post-comment-form] input').focus();
    if (button.matches('[data-post-comment-like]')) button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
    if (button.matches('[data-post-save]')) {
      const saved = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(saved));
      button.querySelector('span:not(.mp-icon)').textContent = saved ? 'Saved' : 'Save post';
    }
    if (button.matches('[data-post-copy]')) {
      void copyPost(post);
      const menu = button.closest('.mp-post-menu');
      if (menu) menu.open = false;
    }
    if (button.matches('[data-post-share]') && !sharing.has(post)) {
      sharing.add(post);
      try {
        const data = { title: post.querySelector('.mp-post-identity strong').textContent, text: post.querySelector('.mp-post-caption').textContent, url: postLink() };
        if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
          try {
            await navigator.share(data);
            pulse(post, 'share');
            void counters.get(post)?.add('share');
          } catch (error) { if (error.name !== 'AbortError') await copyPost(post); }
        } else { await copyPost(post); }
      } finally { sharing.delete(post); }
    }
  });
  // Simulated posting failure; no comment is sent or stored remotely.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-post-comment-form]')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const input = form.querySelector('input');
    const text = input.value.trim();
    if (!text) return;
    const post = form.closest('[data-social-post]');
    const submit = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-post-comment-status]');
    form.setAttribute('aria-busy', 'true');
    input.readOnly = true;
    submit.disabled = true;
    status.textContent = 'Posting…';
    await new Promise(resolve => setTimeout(resolve, 1000));
    form.removeAttribute('aria-busy');
    input.readOnly = false;
    submit.disabled = false;
    status.textContent = '';
    if (form.closest('#MarketCartDialog')?.open) post.querySelector('.mp-post-error-dialog').showModal();
  });
  document.querySelectorAll('.mp-post-error-dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (dialog.closest('#MarketCartDialog')?.open) {
        const target = dialog.classList.contains('mp-post-share-dialog') ? '[data-post-share]' : '[data-post-comment-form] input';
        dialog.closest('[data-social-post]').querySelector(target).focus();
      }
    });
  });
  // A shared permalink opens the post without adding anything to the cart.
  if (new URL(location.href).searchParams.get('post') === 'aldo-cart-post') {
    document.querySelector('.mp-header [data-open-cart]')?.click();
    requestAnimationFrame(() => document.getElementById('aldo-post')?.scrollIntoView({ block: 'center' }));
  }
})();
